module.exports = "<div class=\"page-landing\" style=\"float: left\">\r\n      Welcome to Affinity\r\n</div>"